import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import {
  WrapperModuleAudience,
  WrapperModuleReports,
  Wrapper2Col,
  StyledCol
} from './style';

import ChannelShare from './channelShare';
import Ranking from './ranking';
import ShareReport from './shareReport';
import MonthAudience from './monthAudience';
import ModalEmail from './modalEmail';

import { formatTxt } from '../../../utils/mocks/js/formats';
import { ContentGrouping } from '../../core/ContentGrouping';

import { dataDailyShareModel } from '../../../utils/models';
import { getBasicDate, getMonthDate, getDay } from '../../../utils/dates';

class ModulesWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModalEmail: false,
      pdfUrl: '',
      pdfName: '',
      xlsUrl: '',
      xlsName: ''
    };
  }

  render() {
    const {
      dataDailyShare,
      dataRanking,
      dataMonthlyShare,
      dataDailyReports,
      isOnErrorLoadData
    } = this.props;

    const { showModalEmail, pdfUrl, pdfName, xlsUrl, xlsName } = this.state;

    const basicDate = getBasicDate(dataDailyShare.day);
    const monthDate = getMonthDate(dataDailyShare.day);
    const basicDay = getDay(dataDailyShare.day);
    const isExpandable = window.innerWidth > 721;

    return isOnErrorLoadData ? (
      <p>Lo sentimos, pero no tenemos datos para la fecha seleccionada</p>
    ) : (
      <Fragment>
        <WrapperModuleAudience className="MonthAudience">
          <MonthAudience
            data={dataMonthlyShare}
            formats={formatTxt}
            day={basicDay}
            date={monthDate}
          />
        </WrapperModuleAudience>
        <Wrapper2Col>
          <StyledCol>
            <ContentGrouping
              title={`Ranking de programas del día ${basicDate}`}
            >
              <Ranking data={dataRanking} />
            </ContentGrouping>
          </StyledCol>
          <StyledCol>
            <ContentGrouping title="Ranking cadenas">
              <ChannelShare data={dataDailyShare} expandable={isExpandable} />
            </ContentGrouping>
          </StyledCol>
          <WrapperModuleReports>
            <ShareReport
              data={dataDailyReports}
              date={basicDate}
              onClickIconShare={(pdfUrl, pdfName, xlsUrl, xlsName) => {
                this.setState({
                  showModalEmail: true,
                  pdfUrl,
                  pdfName,
                  xlsUrl,
                  xlsName
                });
              }}
            />
          </WrapperModuleReports>
        </Wrapper2Col>
        {showModalEmail && (
          <ModalEmail
            closeModal={() => {
              this.setState({ showModalEmail: false });
            }}
            pdfUrl={pdfUrl}
            pdfName={pdfName}
            xlsUrl={xlsUrl}
            xlsName={xlsName}
          />
        )}
      </Fragment>
    );
  }
}

ModulesWrapper.propTypes = {
  dataDailyShare: dataDailyShareModel,
  dataRanking: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      cadena: PropTypes.string,
      emision: PropTypes.string,
      miles: PropTypes.number,
      indiceTelevisivo: PropTypes.number
    })
  ).isRequired,
  dataMonthlyShare: PropTypes.arrayOf(dataDailyShareModel).isRequired,
  isOnErrorLoadData: PropTypes.bool.isRequired
};

export default ModulesWrapper;
